module.exports = __webpack_public_path__ + "img/work_mode.5cb82446.svg";